// ** MUI Imports
import type { Theme } from '@mui/material/styles';
import type { ComponentsPropsList } from '@mui/material';

// ** Type Import
import type { Settings } from '../../context/settingsContext';

export type OwnerStateThemeType = {
  theme: Theme;
  ownerState: ComponentsPropsList[keyof ComponentsPropsList] & Record<string, unknown>;
};

// ** Overrides Imports
import MuiAlerts from './alerts';
import MuiAppBar from './appBar';
import MuiAutocomplete from './autocomplete';
import MuiAvatar from './avatar';
import MuiBackdrop from './backdrop';
import MuiBadge from './badge';
import MuiBreadcrumb from './breadcrumbs';
import MuiButton from './button';
import MuiCard from './card';
import MuiChip from './chip';
import MuiDataGrid from './dataGrid';
import MuiDialog from './dialog';
import MuiDivider from './divider';
import MuiFab from './fab';
import MuiFormControl from './formControl';
import MuiInput from './input';
import MuiLink from './link';
import MuiList from './list';
import MuiMenu from './menu';
import MuiPagination from './pagination';
import MuiPaper from './paper';
import MuiPickersArrowSwitcher from './pickersArrowSwitcher';
import MuiPopover from './popover';
import MuiRating from './rating';
import MuiSelect from './select';
import MuiSnackbar from './snackbar';
import MuiSwitches from './switches';
import MuiTable from './table';
import MuiTabs from './tabs';
import MuiTimeline from './timeline';
import MuiToggleButton from './toggleButton';
import MuiTooltip from './tooltip';

const Overrides = (settings: Settings) => {
  const { skin, mode } = settings;

  const alerts = MuiAlerts(mode);
  const appBar = MuiAppBar(settings);
  const autocomplete = MuiAutocomplete(skin);
  const avatars = MuiAvatar();
  const backdrop = MuiBackdrop();
  const badge = MuiBadge();
  const breadcrumb = MuiBreadcrumb();
  const button = MuiButton();
  const cards = MuiCard(skin);
  const chip = MuiChip();
  const dataGrid = MuiDataGrid();
  const dialog = MuiDialog(skin);
  const divider = MuiDivider();
  const fabButton = MuiFab();
  const formControl = MuiFormControl();
  const input = MuiInput();
  const link = MuiLink;
  const list = MuiList();
  const menu = MuiMenu(settings);
  const pagination = MuiPagination();
  const paper = MuiPaper(settings);
  const pickersArrowSwitcher = MuiPickersArrowSwitcher;
  const popover = MuiPopover(skin);
  const rating = MuiRating();
  const select = MuiSelect;
  const snackbar = MuiSnackbar(skin);
  const switches = MuiSwitches();
  const tables = MuiTable();
  const tabs = MuiTabs();
  const timeline = MuiTimeline();
  const toggleButton = MuiToggleButton;
  const tooltip = MuiTooltip();

  return Object.assign(
    alerts,
    appBar,
    autocomplete,
    avatars,
    backdrop,
    badge,
    breadcrumb,
    button,
    cards,
    chip,
    dataGrid,
    dialog,
    divider,
    fabButton,
    formControl,
    input,
    link,
    list,
    menu,
    pagination,
    paper,
    pickersArrowSwitcher,
    popover,
    rating,
    select,
    snackbar,
    switches,
    tables,
    tabs,
    timeline,
    toggleButton,
    tooltip,
  );
};

export default Overrides;
